// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"81c76955","488":"221ad720","632":"5c0ad000","747":"bcaa143c"}[chunkId] + ".chunk.js";
};